// src/config.js
export const proxyUrl = 'integration-proxy.rdrive.io';
export const apiUrl = 'uk-v6.rdrive.io';
export const username = 'admin@rdrive.io';
export const password = '';